<template>
  <div>
    <!-- 公司/机构基本信息 -->
    <div
      style="border: 1px solid gray; width:98%; height :460px;margin:auto"
      v-if="basicShow"
    >
      <el-col :span="24">
        <el-form
          :disabled="saveFlag"
          class="systemFont2 systemForm1"
          :model="formData"
          label-position="right"
          label-width="130px"
          ref="formData"
          hide-required-asterisk
        >
          <el-row>
            <!-- 公司/机构基本信息 -->
            <p style="text-align: center; margin-right: 3%; margin-bottom: 2%">
              <span style="margin-left:2.5%" class="systemFont1">{{
                $t("p0201.companyInfo")
              }}</span>
            </p>
            <p></p>
          </el-row>
          <el-row>
            <el-col style="width: 40%;" :offset="3">
              <!-- 注册名称 -->
              <el-form-item
                size="systemSelect3"
                :label="$t('p0201.companyName')"
                prop="companyName"
                :rules="checkCompanyName"
              >
                <div class="automatic">
                  <el-col :span="13" style="width: calc(71% - 5.2rem);">
                    <div>
                      <div slot="reference">
                        <el-input
                          size="reportContentInput"
                          maxlength="125"
                          class="inputWidth1"
                          type="text"
                          v-model="formData.companyName"
                          autocomplete="on"
                          clearable
                          :placeholder="$t('common.required')"
                        >
                        </el-input>
                      </div>
                    </div>
                    <!--企查查获取  -->
                  </el-col>
                  <el-col :span="4" :offset="1" style="width: 5.2rem ">
                    <el-form-item>
                      <el-popover
                        ref="popover"
                        @show="checkCompanyNameLen(formData.companyName)"
                        placement="bottom"
                        style="width:200px"
                        trigger="click"
                        v-model="autoVisabled"
                      >
                        <template v-solt="">
                          <el-table
                            height="320px"
                            v-loading="selfAcquiredLoading"
                            style="font-size:12px;"
                            :header-cell-style="{ padding: '0px' }"
                            :row-style="{ height: '30px' }"
                            :data="companyData"
                            @row-click="selectCompany"
                          >
                            <el-table-column
                              prop="name"
                              width="200"
                              :label="$t('p0201.companyName')"
                            >
                              <template slot-scope="scope">
                                {{ scope.row.name }}
                              </template>
                            </el-table-column>
                          </el-table>
                        </template>
                        <div slot="reference">
                          <el-button
                            @click="searchCompany(formData.companyName)"
                            type="submit"
                            :disabled="saveFlag"
                            class="buttonWidth"
                            :loading="selfAcquiredLoading"
                            >{{ $t("p0201.automatically") }}</el-button
                          >
                        </div>
                      </el-popover>
                    </el-form-item>
                  </el-col>
                </div>
              </el-form-item>
              <!-- 简称 -->
              <el-form-item
                :label="$t('p0201.companyAbbrName')"
                prop="companyAbbrName"
              >
                <el-input
                  v-model="formData.companyAbbrName"
                  size="reportContentInput"
                  class="inputWidth"
                  maxlength="125"
                >
                </el-input>
              </el-form-item>
              <div id="inputWidth">
                <!-- 注册地 -->
                <el-form-item
                  :label="$t('p0201.registerAddr')"
                  prop="registerAddr"
                >
                  <el-col :span="4">
                    <!-- 省 -->
                    <el-form-item prop="province">
                      <el-autocomplete
                        size="systemSelect3"
                        popper-class="localeSelect"
                        :popper-append-to-body="false"
                        v-model="formData.province"
                        :placeholder="$t('p0201.province')"
                        :fetch-suggestions="querySearchProvince"
                        style="width: 100%;"
                        @select="handleSelectProvince"
                        clearable
                        @change="provinceChange"
                        @clear="clearProvince"
                      ></el-autocomplete>
                    </el-form-item>
                  </el-col>
                  <div id="selectWidth">
                    <el-col :span="4" :offset="3">
                      <!-- 市 -->
                      <el-form-item prop="city">
                        <el-autocomplete
                          popper-class="localeSelect"
                          size="systemSelect3"
                          :popper-append-to-body="false"
                          v-model="formData.city"
                          :placeholder="$t('p0201.city')"
                          :fetch-suggestions="querySearchCity"
                          style="width: 100%"
                          @change="cityChange"
                          @select="handleSelectCity"
                          clearable
                          @clear="clearCity"
                          :disabled="formData.province == ''"
                        ></el-autocomplete>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4" :offset="3">
                      <!-- 区 -->
                      <el-form-item prop="county">
                        <el-autocomplete
                          popper-class="localeSelect"
                          size="systemSelect3"
                          :popper-append-to-body="false"
                          v-model="formData.county"
                          :placeholder="$t('p0201.county')"
                          :fetch-suggestions="querySearchCounty"
                          style="width: 100%"
                          clearable
                          :disabled="formData.city == ''"
                        ></el-autocomplete>
                      </el-form-item>
                    </el-col>
                  </div>
                </el-form-item>
              </div>
              <!-- 注册地址 -->
              <el-form-item
                :label="$t('p0201.registerAddrs')"
                prop="registerAddrs"
              >
                <el-input
                  v-model="formData.registeredAddress"
                  size="reportContentInput"
                  class="inputWidth"
                  maxlength="125"
                >
                </el-input>
              </el-form-item>
              <!-- 联系电话 -->
              <el-form-item :label="$t('p0201.telephone')">
                <!-- <el-col :span="8"> -->
                <div style="width:75%;">
                  <div style="width: 5.5rem;display: inline-block;">
                    <el-form-item>
                      <el-select
                        v-model="formData.areaCode"
                        size="systemSelect3"
                      >
                        <el-option
                          v-for="item in areaList"
                          :key="item.phoneAreaId"
                          :label="item.dialCode"
                          :value="item.dialCode"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <!-- </el-col> -->
                  </div>
                  <div
                    style="margin-right: 0;width: calc(100% - 5.8rem); display: inline-block;"
                  >
                    <el-form-item prop="telephoneNumber" :rules="checkPhone">
                      <el-input
                        v-model="formData.telephoneNumber"
                        size="reportContentInput"
                        class="inputWidth1"
                        maxlength="125"
                      >
                      </el-input
                    ></el-form-item>
                  </div>
                </div>
              </el-form-item>
              <!-- 联系地址 -->
              <el-form-item :label="$t('p0201.address')" prop="address">
                <el-input
                  v-model="formData.contactAddress"
                  size="reportContentInput"
                  class="inputWidth"
                  maxlength="125"
                >
                </el-input>
              </el-form-item>
              <!-- 所属行业 -->
              <el-form-item :label="$t('p0201.industry')" prop="industry">
                <el-select
                  class="inputWidth"
                  size="systemSelect3"
                  v-model="formData.industry"
                  :placeholder="$t('p0201.industryName')"
                >
                  <el-option
                    v-for="item in industryList"
                    :key="item.codeKey"
                    :label="item.codeValueZh"
                    :value="item.codeValueZh"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <!-- 公司税号 -->
              <el-form-item
                :rules="checkTaxNumber"
                :label="$t('p0201.companyTaxNumber')"
                prop="companyTaxNumber"
              >
                <el-input
                  v-model="formData.companyTaxNumber"
                  size="reportContentInput"
                  class="inputWidth"
                  maxlength="64"
                  :placeholder="$t('common.required')"
                >
                </el-input>
              </el-form-item>
              <!-- 注册国家/地区 -->
              <el-form-item :label="$t('p0201.conntryName')" prop="conntryName">
                <el-select
                  class="inputWidth"
                  size="systemSelect3"
                  v-model="formData.country"
                  :placeholder="$t('p0201.country')"
                  @change="selectConuntry()"
                >
                  <el-option
                    v-for="item in countryList"
                    :key="item.codeKey"
                    :label="item.codeValueZh"
                    :value="item.codeValueZh"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- 英文名称 -->
              <el-form-item
                :label="$t('p0201.companyEnName')"
                prop="companyEnName"
              >
                <el-input
                  v-model="formData.enName"
                  size="reportContentInput"
                  class="inputWidth"
                  maxlength="64"
                >
                </el-input>
              </el-form-item>
              <!-- 公司代表/联系人 -->
              <el-form-item :label="$t('p0201.contact')" prop="contact">
                <el-input
                  v-model="formData.companyContacts"
                  size="reportContentInput"
                  class="inputWidth"
                  maxlength="64"
                >
                </el-input>
              </el-form-item>
              <!-- 公司网址 -->
              <el-form-item :label="$t('p0201.companyWeb')" prop="companyWeb">
                <el-input
                  v-model="formData.companyWebsite"
                  size="reportContentInput"
                  class="inputWidth"
                  maxlength="64"
                >
                </el-input>
              </el-form-item>
              <!-- 备注 -->
              <el-form-item :label="$t('p0201.remarks')" prop="remarks">
                <el-input
                  v-model="formData.remarks"
                  size="reportContentInput"
                  class="inputWidth"
                  maxlength="64"
                >
                </el-input>
              </el-form-item>
              <!-- 公司资料 -->
              <el-form-item
                id="el-form-item__content11"
                :label="$t('p0201.information')"
                prop="locationCode"
              >
                <uploadFile
                  ref="uploadCardFile_1"
                  :uploadButtonStyle="uploadButtonStyle"
                  :uploadFile="{
                    locationCode: locationCode,
                    uploadBtnDisplayFlag: uploadBtnDisplayFlag
                  }"
                  :uploadDisable="saveFlag"
                >
                </uploadFile>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="foot-container">
            <!-- 保存  -->
            <el-button type="submit" :disabled="saveFlag" @click="submit()">{{
              $t("p0201.save")
            }}</el-button>
          </el-row>
        </el-form>
      </el-col>
    </div>
    <p></p>
    <!-- 公司/机构人员信息 -->
    <div
      style="border: 1px solid gray; width:98%;  margin:auto "
      v-if="isReloadData"
    >
      <el-row>
        <p style="text-align: center; margin-right: 3%; ">
          <span style="margin-left:2.5%" class="systemFont1">{{
            $t("p0201.companyUserInfo")
          }}</span>
        </p>
        <!-- 添加已注册用户 -->
        <div style="border: 1px solid gray; width:97%;margin:auto;">
          <p style="text-align: left;">
            <span class="systemFont1" style="margin-left:20px;">{{
              $t("p0201companyUserInfo.addRegisteredUser")
            }}</span>
          </p>
          <el-form
            ref="queryForm"
            :model="queryForm"
            label-position="right"
            label-width="100px"
            class="systemFont2"
          >
            <el-row>
              <p></p>
              <el-col :span="24">
                <!-- 个人用户检索入力框 -->
                <el-col :span="10" :offset="6">
                  <el-form-item
                    id="personalUserLabel"
                    :label="$t('p0201companyUserInfo.personalUser')"
                  >
                    <el-input
                      name="queryCriteria"
                      type="text"
                      v-model="queryForm.queryCriteria"
                      clearable
                      :placeholder="
                        $t('p0201companyUserInfo.searchPlaceholder')
                      "
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <img
                    src="../../assets/query2.svg"
                    width="36px"
                    height="36px"
                    style="cursor: pointer"
                    @click="getUserDetail(true)"
                  />
                </el-col>
              </el-col>
            </el-row>
          </el-form>
          <el-row><br /></el-row>
          <el-row>
            <el-col>
              <el-table
                :data="companyUserDetail"
                tooltip-effect="dark"
                style="width:90%;margin:auto"
                @selection-change="handleSelectionChange"
              >
                <el-table-column
                  type="selection"
                  width="55"
                  :selectable="selectable"
                ></el-table-column>
                <!-- 头像 -->
                <el-table-column
                  :label="$t('p0201companyUserInfo.headPortrait')"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-avatar
                      :src="viewHeadPortrait(scope.row.headPortrait)"
                      :key="scope.row.headPortrait"
                      :size="30"
                    ></el-avatar>
                  </template>
                </el-table-column>
                <!-- 姓名-->
                <el-table-column
                  prop="name"
                  :label="$t('p0201companyUserInfo.userName')"
                  align="center"
                ></el-table-column>
                <!-- 英文姓名 -->
                <el-table-column
                  prop="englishName"
                  :label="$t('p0201companyUserInfo.englishName')"
                  align="center"
                ></el-table-column>
                <!-- 昵称 -->
                <el-table-column
                  prop="nickname"
                  :label="$t('p0201companyUserInfo.nickname')"
                  align="center"
                ></el-table-column>
                <!-- 注册日期 -->
                <el-table-column
                  prop="createTime"
                  :label="$t('p0201companyUserInfo.registerDate')"
                  align="center"
                ></el-table-column>
                <!-- 手机 -->
                <el-table-column
                  prop="phoneNo"
                  :label="$t('p0201companyUserInfo.phoneNo')"
                  align="center"
                ></el-table-column>
                <!-- 邮箱 -->
                <!-- <el-table-column
                    prop="email"
                    :label="$t('p0201companyUserInfo.email')"
                    align="center"
                  ></el-table-column> -->
              </el-table>
            </el-col>
          </el-row>
          <!-- 分页 -->
          <el-row style="text-align: right; margin: 20px">
            <el-col :span="24">
              <div class="block">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page.sync="currentPage"
                  :page-sizes="[6, 20]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next"
                  :total="total"
                >
                </el-pagination>
              </div>
            </el-col>
          </el-row>
          <el-row class="foot-container">
            <el-tooltip
              :content="$t('p0201.pleaseAddCompInfo')"
              :disabled="tipDisabled"
              placement="top-start"
              style="position:[50%, 50%];"
            >
              <span>
                <!-- 添加  -->
                <el-button
                  type="submit"
                  :disabled="btnDisabled"
                  @click="registedUserToCom"
                  >{{ $t("p0201companyUserInfo.add") }}</el-button
                >
              </span>
            </el-tooltip>
          </el-row>
          <el-row><br /><br /></el-row>
        </div>
        <p></p>
        <!-- 添加未注册用户 -->
        <div
          style="border: 1px solid gray; height:290px; width:97%;margin:auto;"
        >
          <p style="text-align: left;">
            <span class="systemFont1" style="margin-left:20px;">{{
              $t("p0201companyUserInfo.addNoRegisterUser")
            }}</span>
          </p>
          <el-col :span="24">
            <el-form
              :rules="rules"
              ref="noAddForm"
              class="systemFont2 systemForm1"
              :model="noAddForm"
              label-position="right"
              label-width="120px"
              hide-required-asterisk
            >
              <el-row>
                <p></p>
              </el-row>
              <el-row>
                <el-col style="width: 39%;" :offset="3">
                  <!-- 姓名 -->
                  <el-form-item label-width="0px" style="margin-left:50px">
                    <el-col :span="10">
                      <!-- 姓 -->
                      <el-form-item
                        :label="$t('p0211.lastName')"
                        prop="lastName"
                        label-width="70px"
                      >
                        <el-input
                          v-model="noAddForm.lastName"
                          size="reportContentInput"
                          class="inputWidth2"
                          maxlength="125"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <!-- 名 -->
                      <el-form-item
                        :label="$t('p0211.firstName')"
                        prop="firstName"
                        label-width="70px"
                      >
                        <el-input
                          v-model="noAddForm.firstName"
                          size="reportContentInput"
                          class="inputWidth2"
                          maxlength="125"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-form-item>
                  <!-- 手机 -->
                  <el-form-item :label="$t('p0201companyUserInfo.phoneNo')">
                    <div style="width:75%;">
                      <div style="width: 5.5rem;display: inline-block;">
                        <el-form-item>
                          <el-select
                            size="systemSelect3"
                            v-model="noAddForm.phoneArea"
                          >
                            <el-option
                              v-for="item in areaList"
                              :key="item.phoneAreaId"
                              :label="item.dialCode"
                              :value="item.dialCode"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                      <div
                        style="margin-right: 0;width: calc(100% - 5.8rem); display: inline-block;"
                      >
                        <el-form-item prop="phone">
                          <el-input
                            size="reportContentInput"
                            class="inputWidth1"
                            maxlength="125"
                            v-model="noAddForm.phone"
                          >
                          </el-input>
                        </el-form-item>
                      </div>
                    </div>
                  </el-form-item>
                  <!-- 职位 -->
                  <el-form-item
                    :label="$t('p0201companyUserInfo.position')"
                    prop="position"
                  >
                    <el-input
                      v-model="noAddForm.position"
                      size="reportContentInput"
                      class="inputWidth"
                      maxlength="125"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <!-- 邮箱 -->
                  <el-form-item
                    :label="$t('p0201companyUserInfo.email')"
                    prop="email"
                  >
                    <el-input
                      v-model="noAddForm.email"
                      size="reportContentInput"
                      class="inputWidth"
                      maxlength="64"
                    >
                    </el-input>
                  </el-form-item>

                  <!-- 部门 -->
                  <el-form-item
                    :label="$t('p0201companyUserInfo.department')"
                    prop="department"
                  >
                    <el-input
                      v-model="noAddForm.department"
                      size="reportContentInput"
                      class="inputWidth"
                      maxlength="64"
                    >
                    </el-input>
                  </el-form-item>
                  <!-- 备注 -->
                  <el-form-item :label="$t('p0201.remarks')" prop="remarks">
                    <el-input
                      v-model="noAddForm.remarks"
                      size="reportContentInput"
                      class="inputWidth"
                      maxlength="64"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="foot-container">
                <el-tooltip
                  :content="$t('p0201.pleaseAddCompInfo')"
                  :disabled="tipDisabled"
                  placement="top-start"
                >
                  <span>
                    <!-- 添加  -->
                    <el-button
                      type="submit"
                      @click="addNoRegisterUser"
                      :disabled="btnDisabled"
                      >{{ $t("p0201companyUserInfo.add") }}</el-button
                    >
                  </span>
                </el-tooltip>
              </el-row>
            </el-form>
          </el-col>
        </div>
        <p></p>
        <!-- 公司/机构人员信息一览 -->
        <div
          style="border: 1px solid gray; height:auto; width:97%;margin:auto;  margin-bottom:2%;"
        >
          <p style="text-align: left;">
            <span class="systemFont1" style="margin-left:20px;">{{
              $t("p0201companyUserInfo.view")
            }}</span>
          </p>
          <el-row>
            <el-col>
              <el-table
                :data="companyUserView"
                tooltip-effect="dark"
                style="width:90%;margin:auto ; margin-bottom:2%;"
              >
                <!-- 姓名-->
                <el-table-column
                  prop="lastName"
                  :label="$t('p0201companyUserInfo.userName')"
                  align="center"
                ></el-table-column>
                <!-- 部门 -->
                <el-table-column
                  prop="department"
                  :label="$t('p0201companyUserInfo.department')"
                  align="center"
                ></el-table-column>
                <!-- 职位 -->
                <el-table-column
                  prop="duties"
                  :label="$t('p0201companyUserInfo.position')"
                  align="center"
                ></el-table-column>
                <!-- 手机 -->
                <el-table-column
                  prop="phone"
                  :label="$t('p0201companyUserInfo.phoneNo')"
                  align="center"
                ></el-table-column>
                <!-- 邮箱 -->
                <el-table-column
                  prop="email"
                  :label="$t('p0201companyUserInfo.email')"
                  align="center"
                ></el-table-column>
                <!-- 操作 -->
                <el-table-column :label="$t('common.operation')" align="center">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="text"
                      @click="deleteById(scope.$index, scope.row)"
                      >&nbsp;{{ $t("common.delete") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-col></el-row
          >
          <el-row><br /><br /></el-row>
        </div>
      </el-row>
    </div>
    <p>&nbsp;</p>
  </div>
</template>

<script>
import qs from "qs";
import uploadFile from "../../components/Common/UploadAttachment.vue";
import { build20Id } from "../../utils/buildId.js";
export default {
  components: {
    uploadFile
  },
  data() {
    var selfAcquiredLoading = false;
    //验证手机号的正则表达式
    // let reg = /^(((13[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[3-8]{1})|(18[0-9]{1})|(19[0-9]{1})|(14[5-7]{1}))+\d{8})$/;
    //验证方法
    var validatorPhone = (phone, value, callback) => {
      if (value === "") {
        callback();
      } else if (!reg.test(value)) {
        return callback(new Error(this.$t("p0201.checkTel")));
      }
      callback();
    };
    var validateDutyParagraphBlank = (rule, value, callback) => {
      var Reg = /^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/;
      if (value === "") {
        return callback(new Error(this.$t("p0201.enterTaxNumber")));
      }
      if (!value) {
        return callback(
          new Error(
            this.$t("p0201companyUserInfo.incorrectFormatOfEnterpriseTaxNumber")
          )
        );
      }
      if (!this.isForeign && !Reg.test(value)) {
        return callback(
          new Error(
            this.$t("p0201companyUserInfo.incorrectFormatOfEnterpriseTaxNumber")
          )
        );
      }
      callback();
    };
    //电话邮箱格式
    var validateEmAndPho = (rule, value, callback) => {
      if (!this.noAddForm.email && !this.noAddForm.phone) {
        return callback(
          new Error(this.$t("p0201companyUserInfo.validateEmAndPho"))
        );
      } else if (this.noAddForm.email) {
        this.$refs.noAddForm.clearValidate("phone");
        callback();
      } else if (this.noAddForm.phone) {
        this.$refs.noAddForm.clearValidate("email");
        callback();
      }
      callback();
    };
    // 验证规则 - 姓
    const checkLastName = (rule, value, callback) => {
      const checkNotNull = this.checkNotNull(this.noAddForm.firstName);
      const isChinese = /^[\u4e00-\u9fa5]+$/.test(value); // 判断是否为中文
      const isEnglish = /^[a-zA-Z]+$/.test(value); // 判断是否为英文
      if ((isChinese && !isEnglish) || (isEnglish && !isChinese)) {
        const isChineseFirstName = /^[\u4e00-\u9fa5]+$/.test(
          this.noAddForm.firstName
        ); // 获取姓是否为中文
        const isEnglishFirstName = /^[a-zA-Z]+$/.test(this.noAddForm.firstName); // 获取姓是否为英文
        if (checkNotNull && isChineseFirstName) {
          // 姓是中文
          if (value && !/^[\u4e00-\u9fa5]+$/.test(value)) {
            // 名不是中文
            callback(new Error(this.$t("p0211.msg2"))); // 校验不通过，抛出错误信息
          } else {
            this.$refs.noAddForm.clearValidate("firstName");
            callback(); // 校验通过
          }
        } else if (checkNotNull && isEnglishFirstName) {
          // 姓是英文
          if (value && !/^[a-zA-Z]+$/.test(value)) {
            // 名不是英文
            callback(new Error(this.$t("p0211.msg2"))); // 校验不通过，抛出错误信息
          } else {
            this.$refs.noAddForm.clearValidate("firstName");
            callback(); // 校验通过
          }
        } else if (checkNotNull) {
          // 姓不是中文也不是英文
          callback(new Error(this.$t("p0211.msg2"))); // 校验不通过，抛出错误信息
        }
      } else {
        callback(new Error(this.$t("p0211.msg3"))); // 校验不通过，抛出错误信息
      }
    };

    // 验证规则 - 名
    const checkFirstName = (rule, value, callback) => {
      const checkNotNull = this.checkNotNull(this.noAddForm.lastName);
      const isChineseLastName = /^[\u4e00-\u9fa5]+$/.test(
        this.noAddForm.lastName
      ); // 获取姓是否为中文
      const isEnglishLastName = /^[a-zA-Z]+$/.test(this.noAddForm.lastName); // 获取姓是否为英文
      const isChinese = /^[\u4e00-\u9fa5]+$/.test(value); // 判断是否为中文
      const isEnglish = /^[a-zA-Z]+$/.test(value); // 判断是否为英文
      if ((isChinese && !isEnglish) || (isEnglish && !isChinese)) {
        // 判断语言是否一致
        if (checkNotNull && isChineseLastName) {
          // 姓是中文
          if (value && !/^[\u4e00-\u9fa5]+$/.test(value)) {
            // 名不是中文
            callback(new Error(this.$t("p0211.msg2"))); // 校验不通过，抛出错误信息
          } else {
            this.$refs.noAddForm.clearValidate("lastName");
            callback(); // 校验通过
          }
        } else if (checkNotNull && isEnglishLastName) {
          // 姓是英文
          if (value && !/^[a-zA-Z]+$/.test(value)) {
            // 名不是英文
            callback(new Error(this.$t("p0211.msg2"))); // 校验不通过，抛出错误信息
          } else {
            this.$refs.noAddForm.clearValidate("lastName");
            callback(); // 校验通过
          }
        } else if (checkNotNull) {
          // 姓不是中文也不是英文
          callback(new Error(this.$t("p0211.msg2"))); // 校验不通过，抛出错误信息
        }
      } else {
        callback(new Error(this.$t("p0211.msg3"))); // 校验不通过，抛出错误信息
      }
    };
    return {
      uploadButtonStyle: 1,
      //loading
      selfAcquiredLoading: selfAcquiredLoading,
      // 查询条件
      queryForm: {
        queryCriteria: ""
      },
      //第二个div
      isReloadData: true,
      // 公司/机构人员信息一览
      companyUserView: [],
      // 后台用户信息
      companyUserDetail: [],
      //多选状态
      // selectable: true,
      //添加未注册用户
      noAddForm: {
        lastName: "",
        firstName: "",
        department: "",
        position: "",
        remarks: "",
        email: "",
        phone: "",
        phoneArea: "+86"
      },
      // btnDisabled: localStorage.getItem("newRegCompanyId"),
      //按钮状态
      tipDisabled: false,
      btnDisabled: true,
      countryList: [],
      // 页面载入状态
      // pageLoading: false,
      viewFlag: true,
      //新增表单
      formData: {
        companyName: "",
        province: "",
        city: "",
        county: "",
        companyTaxNumber: "",
        areaCode: "+86",
        country: "中国"
      },
      // 保存编辑按钮
      // editSave: true,
      //公司信息显示状态
      basicShow: true,
      //行业list
      industryList: [],
      // 上传按钮控件是否显示按钮（重新加载用）
      uploadFileReloadFlag: true,
      // 上传按钮显示标志
      uploadBtnDisplayFlag: true,
      // 位置关联Code
      locationCode: build20Id(),
      // 公司数据
      companyData: [],
      form: {},
      // 当前页
      currentPage: 1,
      // 每页件数
      pageSize: 6,
      total: 0,
      saveFlag: false,
      total1: 0,
      //选择的用户
      multipleSelection: [],
      //用户id列表
      userIds: [],
      //地区
      chineArea: [],
      // addressData: regionData,
      //省
      provinces: [],
      //市
      cities: [],
      //默认头像
      defaultImg: require("../../assets/headPortrait.png"),
      //禁用列表:
      indexList: [],
      // 区
      counties: [],
      // 上传文件列表
      uploadFileList: [],
      // 区号列表
      areaList: [],
      // 检索条件保持变量
      tmpQueryStr: "",
      // 公司注册校验
      checkCompanyName: [
        {
          required: true,
          message: this.$t("p0201.enterCompanyName"),
          trigger: "blur"
        }
      ],
      checkTaxNumber: [
        {
          required: true,
          validator: validateDutyParagraphBlank,
          trigger: "blur"
        }
      ],
      checkPhone: [
        {
          required: false,
          trigger: "blur",
          validator: (r, v, b) => {
            v && !/^(?:(?:\+|00)86)?1\d{10}$/.test(v)
              ? b(this.$t("p0201.checkTel"))
              : b();
          }
        }
      ],
      // 未注册用户校验规则
      rules: {
        lastName: [
          {
            required: true,
            message: this.$t("p0211.checkLastName"),
            trigger: "blur"
          },
          { required: false, validator: checkLastName, trigger: "blur" }
        ],

        firstName: [
          {
            required: true,
            message: this.$t("p0211.checkFirstName"),
            trigger: "blur"
          },
          { required: false, validator: checkFirstName, trigger: "blur" }
        ],
        email: [
          {
            required: true,
            validator: validateEmAndPho,
            trigger: "blur"
          },
          {
            pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
            message: this.$t("p0211.correctEmail"),
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            validator: validateEmAndPho,
            trigger: "blur"
          },
          {
            pattern: /(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            message: this.$t("p0201.checkTel"),
            trigger: "blur"
          }
        ]
      },
      index1: 0,
      //企查查弹框
      autoVisabled: false,
      isForeign: false
    };
  },
  props: [],
  mounted() {
    this.getCountry();
    this.getIndustry();
    this.getChineArea();
    // this.initFileUpload();
    this.getArea();
    this.getUserDetail(false);
    localStorage.setItem("newRegCompanyId", "");
  },
  methods: {
    checkNotNull(str) {
      if (str === null || str === "" || typeof str === "undefined") {
        return false;
      } else {
        return true;
      }
    },
    selectable(row, index) {
      for (let i = 0; i < this.companyUserView.length; i++) {
        if (row.userId == this.companyUserView[i].userId) {
          return false;
        }
      }
      return true;
      // 函数必须有返回值且是布尔值
      // 页面刷新后该函数会执行 N 次进行判断(N 为表格行数)
      // 如果没有返回值则默认返回false(全部无法选中)
    },
    //选择的用户
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //添加未注册用户到公司
    addNoRegisterUser() {
      this.$refs.noAddForm.validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: this.$t("common.loading"),
            spinner: "el-icon-loading",
            background: "hsla(0, 0%, 100%, 0.9)",
            target: document.querySelector("#main-container")
          });
          // console.log(this.noAddForm);

          let url;
          let params;
          url = "/api/CompanyCusAdd/addNoRegisteredUser";
          params = {
            lastName: this.noAddForm.lastName,
            firstName: this.noAddForm.firstName,
            department: this.noAddForm.department,
            duties: this.noAddForm.position,
            phoneArea: this.noAddForm.phoneArea,
            remarks: this.noAddForm.remarks,
            phone: this.noAddForm.phone,
            email: this.noAddForm.email,
            companyId: localStorage.getItem("newRegCompanyId"),
            loginUid: localStorage.getItem("userId")
          };
          // console.log(params);
          this.$http
            .post(url, qs.stringify(params))
            .then(response => {
              loading.close();
              this.response = JSON.stringify(response.data);
              if (response.data.code === 200) {
                loading.close();
                this.$message.success(this.$t("p0323.addedSuccessfully"));
                this.companyUserView = response.data.data;
                this.noAddForm = {};
                this.noAddForm.phoneArea = "+86";
              } else {
                loading.close();
                this.$message.error(response.data.message);
              }
            })
            .catch(err => {
              loading.close();
              console.log(err);
              this.$message.error(this.$t("common.anErrorOccurred"));
            });
        }
      });
    },
    //添加已注册用户到公司
    registedUserToCom() {
      // console.log(this.multipleSelection);
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        spinner: "el-icon-loading",
        background: "hsla(0, 0%, 100%, 0.9)",
        target: document.querySelector("#main-container")
      });
      this.userIds = this.multipleSelection.map(item => {
        return item.userId;
      });
      // console.log(this.userIds);
      let url = "/api/CompanyCusAdd/addRegisteredUser";
      let params = {
        companyId: localStorage.getItem("newRegCompanyId"),
        userIds: this.userIds,
        loginUid: localStorage.getItem("userId")
      };
      // console.log(params);
      this.$http
        .post(url, qs.stringify(params))
        .then(response => {
          this.response = JSON.stringify(response.data);
          if (response.data.code === 200) {
            loading.close();
            this.$message.success("添加成功!");
            // console.log(response.data.data);
            let dataList = response.data.data;
            this.companyUserView = dataList;
            // let { userId } = dataList;
            // console.log(userId);
            // this.indexList[userId]
          } else {
            loading.close();
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          loading.close();
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 公司机构用户一览检索
    getUserDetail(val) {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        spinner: "el-icon-loading",
        background: "hsla(0, 0%, 100%, 0.9)",
        target: document.querySelector("#main-container")
      });
      // this.pageLoading = true;
      if (val) {
        this.currentPage = 1;
        this.total = 0;
        this.tmpQueryStr = this.queryForm.queryCriteria;
      }
      // 换页时，检索条件还原
      this.queryForm.queryCriteria = this.tmpQueryStr;
      let url = "/api/CompanyCusAdd/queryComUserInfo";
      this.$http
        .post(
          url,
          qs.stringify({
            queryCriteria: this.tmpQueryStr,
            currentSize: (this.currentPage - 1) * this.pageSize,
            pageSize: this.pageSize,
            total: this.total
          })
        )
        .then(response => {
          // this.pageLoading = false;
          this.response = JSON.stringify(response.data);
          if (response.data.code === 200) {
            loading.close();
            this.companyUserDetail = response.data.data;
            //判断是否初始化
            if (this.currentPage == 1) {
              this.companyUserDetail = response.data.data;
              this.total = this.companyUserDetail[0].total;
            } else {
              this.companyUserDetail = response.data.data;
            }
          } else {
            loading.close();
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          loading.close();
          console.log(err);
          // this.pageLoading = false;
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 头像图片显示
    viewHeadPortrait(imgCodeStr) {
      return imgCodeStr == null
        ? this.defaultImg
        : "data:image/png;base64," + imgCodeStr;
    },
    // 附件提交
    async upload() {
      // 风险分析1
      await this.$refs.uploadCardFile_1.submitUploadFile();
    },

    // 改变上传文件的状态
    changeUploadFileStatus() {
      // console.log(this.uploadFile.uploadBtnDisplayFlag) //= !this.uploadFile.uploadBtnDisplayFlag;
      this.uploadBtnDisplayFlag = !this.uploadBtnDisplayFlag;
      this.reloadUploadFile();
    },

    // 重新加载上传附件控件
    async reloadUploadFile() {
      this.uploadFileReloadFlag = false;
      await this.$nextTick();
      this.uploadFileReloadFlag = true;
    },
    // 国家适配中文
    checkCountry() {
      // alert(1)
      if (localStorage.locale === "zh") {
        // alert(2)
        if (this.formData.conuntry === "China") {
          // alert(3)
          this.formData.conuntry = "中国";
        }
      }
    },
    initFileUpload() {
      let url = "/api/CompanyCusAdd/initFileUpload";
      // 访问对应的后端的api获取登录信息
      this.$http.post(url).then(response => {
        console.log(response.data.data);
        this.locationCode = response.data.data;
        // sessionStorage.setItem("filePathId",response.data.data)
      });
    },
    //添加公司
    submit() {
      // console.log(this.formData);
      this.$refs.formData.validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: this.$t("common.loading"),
            spinner: "el-icon-loading",
            background: "hsla(0, 0%, 100%, 0.9)",
            target: document.querySelector("#main-container")
          });
          this.upload();
          if (this.$refs.uploadCardFile_1.uploadFileList.length == 0) {
            this.locationCode = null;
          }
          console.log(this.$refs.uploadCardFile_1.uploadFileList);
          let url;
          let params;
          this.checkCountry();
          url = "/api/CompanyCusAdd/save";
          params = {
            companyName: this.formData.companyName,
            companyAbbrName: this.formData.companyAbbrName,
            companyTaxNumber: this.formData.companyTaxNumber,
            country: this.formData.country,
            province: this.formData.province,
            city: this.formData.city,
            area: this.formData.county,
            enName: this.formData.enName,
            registeredAddress: this.formData.registeredAddress,
            companyContacts: this.formData.companyContacts,
            areaCode: this.formData.areaCode,
            telephoneNumber: this.formData.telephoneNumber,
            companyWebsite: this.formData.companyWebsite,
            contactAddress: this.formData.contactAddress,
            remarks: this.formData.remarks,
            industry: this.formData.industry,
            registTime: this.formData.registTime,
            filePathId: this.locationCode,
            // registDt: null,
            registUserId: localStorage.getItem("userId")
          };
          // console.log(params);
          this.$http
            .post(url, qs.stringify(params))
            .then(response => {
              this.response = JSON.stringify(response.data);
              localStorage.setItem("newRegCompanyId", response.data.data);
              if (response.data.code === 200) {
                loading.close();
                this.btnDisabled = false;
                this.tipDisabled = true;
                this.saveFlag = true;
                // this.formData = {};
                // this.initFileUpload();
                // this.uploadFileList = this.$refs.uploadCardFile_1.getUploadFileList();
                // for (let i = 0; i < this.uploadFileList.length; i++) {
                //   this.$refs.uploadCardFile_1.handleRemove(
                //     this.uploadFileList[i],
                //     this.uploadFileList
                //   );
                // }
                // this.formData.areaCode = "+86";
                // this.formData.country = "中国";
              } else if (response.data.message === "该公司已存在") {
                loading.close();
                this.$message.error(this.$t("p0201.companyAlreadyExists"));
              } else {
                loading.close();
                this.$message.error(response.data.message);
              }
            })
            .catch(err => {
              loading.close();
              console.log(err);
              this.$message.error(this.$t("common.anErrorOccurred"));
            });
        }
      });
    },
    // 模糊搜索公司名称列表
    async searchCompany(companyName) {
      this.$refs.popover.doClose();
      this.selfAcquiredLoading = true;
      this.companyData = [];
      if (!companyName || companyName.length < 4) {
        // this.$message.error(this.$t("loginPage.loginFailed"));
        this.$message.error(this.$t("p0201.enterCompanyInformation"));
        this.selfAcquiredLoading = false;
        this.$refs.popover.doClose();
        return;
      }
      this.autoVisabled = false;
      let url = "/api/login/company/search";
      console.log(this.selfAcquiredLoading);
      // 访问对应的后端的api获取登录信息
      this.$http
        .post(
          url,
          qs.stringify({
            name: companyName
          })
        )
        .then(async response => {
          // console.log(response.data.data);
          this.response = JSON.stringify(response.data);
          if (response.data.code === 200) {
            // loading.close();
            this.$message({
              message: response.data.message,
              type: "success"
            });
            this.companyData = response.data.data;
            this.selfAcquiredLoading = false;
            // console.log(this.selfAcquiredLoading);
            this.autoVisabled = true;
            this.$refs.popover.doShow();
          } else {
            this.selfAcquiredLoading = false;
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          // loading.close();
          this.loading = false;
          this.selfAcquiredLoading = false;
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
      // this.selfAcquiredLoading = false;
    },
    // 选择公司事件
    async selectCompany(row, column, event) {
      // 等待查询公司照面
      let companyInfo = await this.searchCompanyPrecise(row.name);
      // console.log("companyInfo",companyInfo);
      this.formData.companyName = companyInfo.name;
      this.formData.companyTaxNumber = companyInfo.creditCode;
      this.formData.country = this.$t("p0201.country");
      this.formData.registeredAddress = companyInfo.address;
      // console.log("saaasd",companyInfo.area.province);
      if (companyInfo.area) {
        // 获取省份代码，地区赋值
        let province = String(companyInfo.area.province).replace("省", "");
        province = province.replace("省", "");
        let provinceCode = this.selectProvincesCodeByName(province);
        this.formData.province = province;
        this.getCityOrRegionData(provinceCode);
        let city = String(companyInfo.area.city).replace("市", "");
        city = city.replace("市", "");
        this.formData.city = city;
        console.log(this.counties);
        // this.getCounty(provinceCode);
        this.handleSelectCity({ value: city });
        console.log(this.counties);
        let county = String(companyInfo.area.county).replace("区", "");
        county = county.replace("区", "");
        this.formData.county = county;
      }
    },

    // 获取公司证照信息
    async searchCompanyPrecise(companyName) {
      let companyPrecise = {};
      let url = "/api/login/company/precise";
      // 访问对应的后端的api获取登录信息
      await this.$http
        .post(
          url,
          qs.stringify({
            name: companyName
          })
        )
        .then(response => {
          // this.response = JSON.stringify(response.data);
          if (response.data.code === 200) {
            this.$message({
              message: response.data.message,
              type: "success"
            });
            this.autoVisabled = false;
            // console.log(response.data.data);
            companyPrecise = response.data.data;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
      return companyPrecise;
    },

    // 根据省查市编号
    selectProvincesCodeByName(locate) {
      // console.log(locate);
      let provList = this.provinces.filter(item => {
        return item.vcName === locate;
      });
      if (provList.length > 0) {
        return provList[0].vcCode;
      } else {
        return null;
      }
    },
    // 根据市查区编号
    selectCitiesCodeByName(locate) {
      // console.log(locate);
      let provList = this.cities.filter(item => {
        return item.vcName === locate;
      });
      if (provList.length > 0) {
        return provList[0].vcCode;
      } else {
        return null;
      }
    },
    // 查市编号
    selectCityCodeByName(locate) {
      return this.cities.filter(item => {
        return item.vcName === locate;
      })[0].vcCode;
    },
    // 查区编号
    selectCountyCodeByName(locate) {
      return this.counties.filter(item => {
        return item.vcName === locate;
      })[0].vcCode;
    },
    // 手动输入省份，前缀过滤选择列表
    querySearchProvince(queryString, callback) {
      var provinces = this.provinces;
      var results = queryString
        ? provinces.filter(province => {
            return (
              province.vcName
                .toLowerCase()
                .indexOf(queryString.toLowerCase()) === 0
            );
          })
        : provinces;
      callback(
        results.map(item => {
          return { value: item.vcName };
        })
      );
    },

    // 手动输入城市，前缀过滤列表
    querySearchCity(queryString, callback) {
      var cities = this.cities;
      var results = queryString
        ? cities.filter(city => {
            return (
              city.vcName.toLowerCase().indexOf(queryString.toLowerCase()) === 0
            );
          })
        : cities;
      callback(
        results.map(item => {
          return { value: item.vcName };
        })
      );
    },
    // 手动输入县，前缀过滤列表
    querySearchCounty(queryString, callback) {
      var counties = this.counties;
      var results = queryString
        ? counties.filter(county => {
            return (
              county.vcName.toLowerCase().indexOf(queryString.toLowerCase()) ===
              0
            );
          })
        : counties;
      // console.log('cityResult',results)
      callback(
        results.map(item => {
          return { value: item.vcName };
        })
      );
    },

    // 手动输入省份改变事件
    provinceChange(province) {
      // 清除区域
      this.formData.city = "";
      // alert(province)
      // alert(this.selectProvincesCodeByName(province))
      // 判断是否存在该省份
      if (this.selectProvincesCodeByName(province)) {
        // alert(1);
        // 加载城市列表
        this.handleSelectProvince({ value: province });
      } else {
        this.cities = [];
      }
    },
    // 手动输入市改变事件
    cityChange(city) {
      this.formData.county = "";
      // 判断是否存在该市
      if (this.selectCitiesCodeByName(city)) {
        // 加载市列表
        this.handleSelectCity({ value: city });
      } else {
        this.counties = [];
      }
    },
    // 选择省份时加载城市列表
    handleSelectProvince(province) {
      // console.log('select',province)
      let proCode = this.selectProvincesCodeByName(province.value);
      this.getCityOrRegionData(proCode);
    },
    // 选择市时加载区列表
    handleSelectCity(city) {
      // console.log('select',city)
      // console.log(city.value);
      let cityCode = this.selectCitiesCodeByName(city.value);
      this.getCounty(cityCode);
    },
    // 清除省份时清除市、区
    clearProvince() {
      this.formData.city = "";
      this.formData.county = "";
    },

    // 清除市时清除区
    clearCity() {
      this.formData.county = "";
      // console.log(this.formData.province);
      // this.handleSelectProvince(this.formData.province);
    },

    // 获取中国城市
    getChineArea() {
      let url = "/api/CompanyCusAdd/getChineArea";
      let params = {};
      this.$http
        .post(url, qs.stringify(params))
        .then(response => {
          this.response = JSON.stringify(response.data);
          if (response.data.code === 200) {
            this.chineArea = response.data.data;
            // console.log(this.chineArea);
            for (var i = 0; i < this.chineArea.length; i++) {
              if (this.chineArea[i].vcCode.length == 10) {
                this.provinces.push(this.chineArea[i]);
              }
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    //获取市
    getCityOrRegionData(val) {
      // alert('getCity')
      // console.log(val.length);
      this.cities = [];
      this.formData.city = "";
      for (var i = 0; i < this.chineArea.length; i++) {
        if (
          val === this.chineArea[i].vcCode.substring(0, 10) &&
          this.chineArea[i].vcCode.length == 12
        ) {
          // console.log(this.chineArea[i].vcCode.length);
          this.cities.push(this.chineArea[i]);
        }
      }
    },
    //获取区
    getCounty(val) {
      // console.log(val.length);
      // alert('getCity')
      this.counties = [];
      this.formData.county = "";
      for (var i = 0; i < this.chineArea.length; i++) {
        if (
          val === this.chineArea[i].vcCode.substring(0, 12) &&
          this.chineArea[i].vcCode.length == 14
        ) {
          this.counties.push(this.chineArea[i]);
        }
      }
    },

    //获取国家
    getCountry() {
      let url = "/api/CompanyCusAdd/queryCountry";
      // 访问对应后端的api获取画面数据
      this.$http
        .post(
          url,
          qs.stringify({
            searchKey: "country_region"
          })
        )
        .then(response => {
          if (response.data.code === 200) {
            this.countryList = response.data.data;
            // console.log(response.data.data);
            // this.yearsList = response.data.data;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message({
            message: "查询失败！",
            type: "error"
          });
        });
    },
    //获取行业
    getIndustry() {
      let url = "/api/CompanyCusAdd/queryIndustry";
      // 访问对应后端的api获取画面数据
      this.$http
        .post(url, qs.stringify({}))
        .then(response => {
          if (response.data.code === 200) {
            this.industryList = response.data.data;
            // console.log(response.data.data);
            // this.yearsList = response.data.data;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message({
            message: "查询失败！",
            type: "error"
          });
        });
    },
    //获取区号
    getArea() {
      let url = "/api/CompanyCusAdd/getPhoneArea";
      // 访问对应后端的api获取画面数据
      this.$http
        .post(url, qs.stringify({}))
        .then(response => {
          if (response.data.code === 200) {
            this.areaList = response.data.data;
            // console.log(this.areaList);
            // this.yearsList = response.data.data;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message({
            message: "查询失败！",
            type: "error"
          });
        });
    },
    //删除已添加的用户
    deleteById(index, row) {
      // console.log(row);
      // console.log(row);
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/CompanyCusAdd/removeUserCompanyByPk";
      this.$http
        .post(
          url,
          qs.stringify({
            userId: row.userId,
            companyId: localStorage.getItem("newRegCompanyId")
          })
        )
        .then(response => {
          this.response = JSON.stringify(response.data);
          if (response.data.code === 200) {
            this.companyUserView.splice(index, 1);
            this.$message({
              message: this.$t("common.deletedSuccessfully"),
              type: "success"
            });
          } else {
            this.$message.error(response.data.message);
          }
          loading.close();
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // upload() {},
    // getUserDetail() {},
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      //判断更改页码是否需要查询
      if (
        this.companyUserDetail == undefined ||
        this.companyUserDetail.length <= 0
      ) {
        return;
      }
      this.getUserDetail(false);
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getUserDetail(false);
      // console.log(`当前页: ${val}`);
    },
    // popover开启时检查公司名称长度是否大于4
    checkCompanyNameLen(companyName) {
      if (companyName.length < 4) {
        this.$refs.popover.doClose();
        return;
      }
    },
    // 注册国家变更
    selectConuntry() {
      // alert(this.formData.country);
      // 国家代码取得
      let countryCode = "";
      let countrySelStr = this.formData.country;
      this.countryList.forEach(function(item, index, array){
        if (item.codeValueZh === countrySelStr) {
          countryCode = item.codeKey;
        }
      });
      // 国内外判定
      this.$refs.formData.clearValidate();
      if (countryCode === "001") {
        this.isForeign = false;
      } else {
        this.isForeign = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.plusAndMinus {
  text-align: left;
}
// 入力框
.inputWidth {
  display: block;
  width: 75%;
}
// 姓名入力框
.inputWidth2 {
  display: block;
  width: 82%;
}
// 头像
// .hdPortraitCss {
//   display: block;
//   padding-left: 10px;
// }
.textAreaCss {
  margin-top: 9px;
}
.foot-container {
  margin-top: 2%;
  margin-left: 40%;
  width: 20%;
  text-align: center;
}
.el-table {
  font-size: 14px;
}
>>> .inputWidth1 {
  width: 100%;
}
>>> .buttonWidth {
  width: 100%;
  min-width: 60px;
  background-color: rgb(255, 255, 255);
  color: rgb(0, 176, 240);
}
>>> .el-table__row {
  height: 42px;
}
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 14px;
}
>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  line-height: 18px;
  border-bottom: 0.5px solid rgb(170, 170, 170);
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}
>>> .el-form-item__label {
  font-size: 14px;
  font-weight: bold;
  color: #000000;
}
#el-form-item__content11 >>> .el-form-item__content {
  position: absolute;
}
>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}
#personalUserLabel >>> .el-form-item__label {
  font-size: 16px;
}
/* 地域列表高度 */
>>> .localeSelect .el-scrollbar {
  max-height: 8rem;
}
// >>> .localeSelect{
//   left:0;
// }
// 地区宽度
#inputWidth >>> .el-col-4 {
  width: 23.6%;
}
// 市 区左边距
#selectWidth >>> .el-col {
  margin-left: 2%;
}
// 表格
#tableStyle >>> .el-table {
  font-size: 12px;
}
>>> .el-table .cell {
  line-height: 30px;
  height: 30px;
}
>>> .el-table .el-table__cell {
  padding: 8.5px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/CustomerInfoBase/P0201.vue